/**
 * src/utils/toast.js - Vue2 专用提示框（绝对居中+超大尺寸，解决偏右）
 * 核心：用margin手动偏移替代transform，彻底避免居中偏右
 */
export function showToast(title, content, type = 'info', duration = 3000) {
    // 1. 安全移除旧提示框
    const oldToast = document.getElementById('vue2-custom-toast');
    if (oldToast) {
        try {
            document.body.removeChild(oldToast);
        } catch (e) {
            oldToast.remove();
        }
    }

    // 2. 创建提示框（脱离Vue样式隔离，全局DOM）
    const toast = document.createElement('div');
    toast.id = 'vue2-custom-toast';
    // ========== 核心：手动计算偏移，绝对居中（解决偏右）==========
    // 固定宽度（避免transform计算异常）+ 手动margin偏移
    const toastWidth = 400; // 【超大尺寸】固定宽度400px，可自行调大
    toast.style.position = 'fixed';
    toast.style.top = '50%';
    toast.style.left = '50%';
    // 手动计算偏移：向左偏移自身宽度的一半，向上偏移自身高度的一半
    toast.style.marginLeft = `-${toastWidth / 2}px`;
    toast.style.marginTop = '-150px'; // 固定向上偏移150px（匹配高度）
    toast.style.width = `${toastWidth}px`; // 固定宽度，避免计算异常
    toast.style.height = '150px'; // 【超大尺寸】固定高度300px
    toast.style.padding = '40px'; // 【超大内边距】放大框体
    toast.style.borderRadius = '20px'; // 超大圆角
    toast.style.color = '#fff';
    toast.style.fontSize = '32px'; // 【超大基础字体】
    toast.style.zIndex = '999999'; // 最高层级
    toast.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.3)';
    toast.style.opacity = '0';
    toast.style.transition = 'all 0.3s ease';
    toast.style.textAlign = 'center';
    toast.style.display = 'flex';
    toast.style.flexDirection = 'column';
    toast.style.justifyContent = 'center';
    toast.style.alignItems = 'center';
    toast.style.pointerEvents = 'none';
    toast.style.boxSizing = 'border-box';
    // 强制覆盖所有样式
    toast.style.setProperty('position', 'fixed', 'important');
    toast.style.setProperty('left', '50%', 'important');
    toast.style.setProperty('marginLeft', `-${toastWidth / 2}px`, 'important');

    // 3. 类型背景色
    const typeStyles = {
        success: { background: '#67c23a' },
        warning: { background: '#e6a23c' },
        error: { background: '#f56c6c' },
        info: { background: '#409eff' }
    };
    Object.assign(toast.style, typeStyles[type]);

    // 4. 内容排版（超大字体）
    toast.innerHTML = `
    <div style="width: 100%;">
      <strong style="font-size: 36px; display: block; margin-bottom: 20px; font-weight: bold;">${title}</strong>
      <span style="font-size: 32px; line-height: 1.6; display: block;">${content}</span>
    </div>
  `;

    // 5. 添加到body（Vue挂载前也能生效）
    if (document.readyState === 'complete') {
        document.body.appendChild(toast);
    } else {
        window.addEventListener('load', () => {
            document.body.appendChild(toast);
        });
    }

    // 6. 显示动画
    setTimeout(() => {
        toast.style.opacity = '1';
    }, 10);

    // 7. 自动关闭
    if (duration > 0) {
        setTimeout(() => {
            toast.style.opacity = '0';
            setTimeout(() => {
                try {
                    document.body.removeChild(toast);
                } catch (e) {
                    toast.remove();
                }
            }, 300);
        }, duration);
    }

    // 调试：打印偏移值，确认居中
    console.log('提示框宽度：', toastWidth, '，左偏移：', -toastWidth/2);
    return toast;
}